var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-color-picker"
  }, [_c('el-color-picker', _vm._g(_vm._b({
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-color-picker', _vm.$attrs, false), _vm.$listeners)), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };